import React from 'react';
import StatsCard from '../StatsCard';
import { HeadacheStats, TensionStats, LloroStats } from '../../types';

interface DashboardStatsProps {
  healthMode: 'headaches' | 'tensions' | 'lloros';
  headacheStats: HeadacheStats | null;
  tensionStats: TensionStats | null;
  lloroStats: LloroStats | null;
}

const DashboardStats: React.FC<DashboardStatsProps> = ({
  healthMode,
  headacheStats,
  tensionStats,
  lloroStats
}) => {
  if (healthMode === 'headaches' && headacheStats) {
    return (
      <div className="stats-section">
        <h2 className="section-title">📊 Resumen de dolores de cabeza</h2>
        <div className="grid grid-cols-3">
          <StatsCard
            title="Total de Registros"
            value={headacheStats.total}
            icon="📈"
            color="var(--primary)"
          />
          <StatsCard
            title="Últimos 30 días"
            value={headacheStats.recent}
            icon="📅"
            color="var(--success)"
          />
          <StatsCard
            title="Más Común"
            value={headacheStats.intensityDistribution[0]?.intensity || 'N/A'}
            icon="⚡"
            color="var(--warning)"
            subtitle={`${headacheStats.intensityDistribution[0]?.percentage || 0}% del total`}
          />
        </div>
      </div>
    );
  }

  if (healthMode === 'tensions') {
    return (
      <div className="stats-section">
        <h2 className="section-title">🩺 Resumen de tensión arterial</h2>
        <div className="grid grid-cols-3">
          <StatsCard
            title="Total de Registros"
            value={tensionStats?.total || 0}
            icon="📈"
            color="var(--success)"
          />
          <StatsCard
            title="Últimos 30 días"
            value={tensionStats?.recent || 0}
            icon="📅"
            color="var(--primary)"
          />
          <StatsCard
            title="Promedio Sistólica"
            value={tensionStats?.averages?.systolic ? `${tensionStats.averages.systolic} mmHg` : 'N/A'}
            icon="💗"
            color="var(--error)"
            subtitle="Presión alta"
          />
        </div>
      </div>
    );
  }

  if (healthMode === 'lloros') {
    return (
      <div className="stats-section">
        <h2 className="section-title">😢 Resumen de lloros</h2>
        <div className="grid grid-cols-3">
          <StatsCard
            title="Total de Registros"
            value={lloroStats?.total || 0}
            icon="📈"
            color="var(--primary)"
          />
          <StatsCard
            title="Últimos 30 días"
            value={lloroStats?.recent || 0}
            icon="📅"
            color="var(--success)"
          />
          <StatsCard
            title="Más Común"
            value={lloroStats?.intensityDistribution?.[0]?.intensity || 'N/A'}
            icon="💧"
            color="var(--warning)"
            subtitle={lloroStats?.intensityDistribution?.[0]?.percentage ? `${lloroStats.intensityDistribution[0].percentage}% del total` : ''}
          />
        </div>
      </div>
    );
  }

  return null;
};

export default DashboardStats;
